import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Import pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import GeneratorPage from './pages/GeneratorPage';
import ProfilePage from './pages/ProfilePage';
import BuyCreditsPage from './pages/BuyCreditsPage';

// Import styles
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            
            {/* Protected routes */}
            <Route 
              path="/generator" 
              element={
                <ProtectedRoute>
                  <GeneratorPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/buy-credits" 
              element={
                <ProtectedRoute>
                  <BuyCreditsPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Auth callback route for email verification */}
            <Route path="/auth/callback" element={<Navigate to="/generator" replace />} />
            
            {/* Catch all route - redirect to landing page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          {/* Toast notifications container - CRITICAL for toast.error() to work */}
          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{
              top: 20,
              left: 20,
              bottom: 20,
              right: 20,
            }}
            toastOptions={{
              // Define default options for all toasts
              className: '',
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
                fontSize: '14px',
                maxWidth: '500px',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                wordBreak: 'break-word',
              },

              // Success toast styling
              success: {
                duration: 3000,
                style: {
                  background: '#10B981',
                  color: '#fff',
                  border: '1px solid #059669',
                },
                iconTheme: {
                  primary: '#fff',
                  secondary: '#10B981',
                },
              },

              // Error toast styling - This is what was missing!
              error: {
                duration: 6000, // Show errors longer
                style: {
                  background: '#EF4444',
                  color: '#fff',
                  border: '1px solid #DC2626',
                  fontWeight: '500',
                },
                iconTheme: {
                  primary: '#fff',
                  secondary: '#EF4444',
                },
              },

              // Loading toast styling
              loading: {
                duration: Infinity,
                style: {
                  background: '#6B7280',
                  color: '#fff',
                },
                iconTheme: {
                  primary: '#fff',
                  secondary: '#6B7280',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;